import React from "react";
import "./Table.css";

export type TableProps = {
  className?: string;
  children?: React.ReactNode;
};

export const Table = ({
  className = "",
  children,
  ...props
}: TableProps & React.ComponentPropsWithoutRef<"table">) => {
  return (
    <div className={`ds2-table-container ${className}`}>
      <table className="ds2-table" {...props}>
        {children}
      </table>
    </div>
  );
};

export type TableHeaderProps = {
  className?: string;
  children?: React.ReactNode;
};

export const TableHeader = ({
  className = "",
  children,
  ...props
}: TableHeaderProps & React.ComponentPropsWithoutRef<"thead">) => {
  return (
    <thead className={`ds2-table-header ${className}`} {...props}>
      {children}
    </thead>
  );
};

export type TableBodyProps = {
  className?: string;
  children?: React.ReactNode;
};

export const TableBody = ({
  className = "",
  children,
  ...props
}: TableBodyProps & React.ComponentPropsWithoutRef<"tbody">) => {
  return (
    <tbody className={`ds2-table-body ${className}`} {...props}>
      {children}
    </tbody>
  );
};

export type TableRowProps = {
  className?: string;
  children?: React.ReactNode;
};

export const TableRow = ({
  className = "",
  children,
  ...props
}: TableRowProps & React.ComponentPropsWithoutRef<"tr">) => {
  return (
    <tr className={`ds2-table-row ${className}`} {...props}>
      {children}
    </tr>
  );
};

export type TableHeadProps = {
  className?: string;
  children?: React.ReactNode;
};

export const TableHead = ({
  className = "",
  children,
  ...props
}: TableHeadProps & React.ComponentPropsWithoutRef<"th">) => {
  return (
    <th className={`ds2-table-head ${className}`} {...props}>
      {children}
    </th>
  );
};

export type TableCellProps = {
  className?: string;
  children?: React.ReactNode;
};

export const TableCell = ({
  className = "",
  children,
  ...props
}: TableCellProps & React.ComponentPropsWithoutRef<"td">) => {
  return (
    <td className={`ds2-table-cell ${className}`} {...props}>
      {children}
    </td>
  );
};